/**
 * @file Page: Error
 * @description A page that displays a prominent error message and allows the user to retry or return to the main menu.
 */
import type React from 'react';
import Button from '../components/atoms/Button';
import { getEnvironment } from '../utils/environment';

interface ErrorPageProps {
  /** The error message to display. */
  message: string | null;
  /** Callback function to handle the retry action. */
  onRetry: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ message, onRetry }) => {
  return (
    <div className="h-full w-full flex flex-col items-center justify-between text-center shadow-lg bg-[#0B161B]">
      <div className="mt-[150px]">
        <h2 className="text-[44px] text-white uppercase">
          something is...
          <br />
          off
        </h2>
        <p className="text-white mt-4 max-w-md font-lato text-[16px]">
          This shouldn't be happening.
          <br />
          Refresh the screen or return home.
        </p>
        <p className="text-gray-400 mt-4 max-w-md font-lato text-lg">
          {message && getEnvironment() !== 'production' && <>"{message}"</>}
        </p>
      </div>

      <div className="w-full px-[12px]">
        <Button
          size="lg"
          onClick={onRetry}
          className="mb-[44px] h-[57px] rounded-[2px] py-[5px] px-5 !text-[#121212] hover:!text-[#121212] bg-[#FF4426] hover:!bg-[#D91E00]"
        >
          Return to Home
        </Button>
      </div>
    </div>
  );
};

export default ErrorPage;
